import { logoBase64 } from "@/assets/logoBase64";
import { useUsuarioLogado } from "@/contexts/autorizacao/usuario";
import { useMenu } from "@/shared/menu/useMenu";
import {
  BorderlessTableOutlined,
  DownloadOutlined,
  HomeOutlined,
  OrderedListOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import styles from "./style.module.css";

export function Sidebar({ collapsed }: { collapsed: boolean }) {
  const { usuarioLogado } = useUsuarioLogado();
  const navigate = useNavigate();
  const { menuSelected, atualizarMenuSelected } = useMenu();
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState<any>(null);

  const handleChangeInstallPwa = () => {
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      //console.log("da pra instalar");
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler, false);
    return () => window.removeEventListener("transitionend", handler);
  }, []);

  return (
    <Layout.Sider
      className={styles.sideBar}
      theme="dark"
      width={250}
      collapsed={collapsed}
    >
      <div
        style={{
          padding: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={logoBase64}
          alt="Logo"
          style={{
            width: collapsed ? 60 : 100,
            userSelect: "none",
            borderRadius: 8,
          }}
          draggable="false"
        />
      </div>
      <Tooltip title={usuarioLogado?.nome}>
        <div className={styles["content-name-user"]}>
          <UserOutlined /> {usuarioLogado?.nome.split(" ")[0]}
        </div>
      </Tooltip>

      {/* <MenuSystem isSidebar /> */}
      <Menu
        theme="dark"
        mode="inline"
        style={{ borderRadius: 8 }}
        onClick={(e) => {
          atualizarMenuSelected([e.key]);
        }}
        selectedKeys={menuSelected}
        items={[
          {
            key: "inicio",
            label: "Início",
            icon: <HomeOutlined />,
            onClick: () => navigate("/inicio"),
          },
          {
            key: "analise-laboratorial",
            label: "Análise Laboratorial",
            icon: <BorderlessTableOutlined />,
            children: [
              {
                key: "requisicao",
                label: "Requisição",
                onClick: () =>
                  navigate("/analises-laboratoriais/requisicoes/lista"),
                icon: <OrderedListOutlined />,
              },
              {
                key: "certificado",
                label: "Certificado",
                onClick: () =>
                  navigate("/analises-laboratoriais/certificados/lista"),
                icon: <OrderedListOutlined />,
              },
            ],
          },
          {
            key: "termo-notificacao",
            label: "Termo de Notificação",
            icon: <BorderlessTableOutlined />,
            children: [
              {
                key: "termo-notificacao-cadastro",
                label: "Cadastramento",
                onClick: () => navigate("/termos-notificacao/lista"),
                icon: <OrderedListOutlined />,
              },
              {
                key: "termo-notificacao-plano-acao",
                label: "Plano de Ação",
                onClick: () => navigate("/termos-notificacao/plano-acao"),
                icon: <OrderedListOutlined />,
              },
            ],
          },
          {
            key: "RAM",
            label: "Relatório de Auditoria e Monitoria",
            icon: <BorderlessTableOutlined />,
            children: [
              {
                key: "ram-cadastro",
                label: "Cadastramento",
                onClick: () => navigate("/RAM/lista"),
                icon: <OrderedListOutlined />,
              },
              {
                key: "ram-plano-acao",
                label: "Plano de Ação",
                onClick: () => navigate("/RAM/plano-acao"),
                icon: <OrderedListOutlined />,
              },
            ],
          },
          {
            key: "perfil",
            label: "Gerenciamento de Perfis",
            icon: <TeamOutlined />,
            onClick: () => navigate("/perfis"),
            style: {
              display: usuarioLogado.perfil.id === 1 ? "block" : "none",
            },
          },
          {
            key: "install",
            icon: <DownloadOutlined />,
            label: "Instalação",
            onClick: () => handleChangeInstallPwa(),
            disabled: !supportsPWA,
          },
        ]}
      />
    </Layout.Sider>
  );
}
